import { useEffect, useState } from "react";

export const useMediaPermissions = () => {
  const [micGranted, setMicGranted] = useState(false);
  const [checking, setChecking] = useState(true);

  const checkMic = async () => {
    setChecking(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
      setMicGranted(true);
      return true;
    } catch (error) {
      console.error("Mic access denied:", error);
      setMicGranted(false);
      return false;
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    checkMic();
  }, []);

  return {
    micGranted,
    checking,
    refresh: checkMic
  };
};

